var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14039 4.02014e-05C5.79539 -0.00430599 4.47199 0.343818 3.29792 1.01082C2.12385 1.67782 1.13875 2.64118 0.437694 3.80792L0 4.52783L2.14272 5.0698L2.37947 4.71388C2.96113 3.84295 3.76319 3.14768 4.70111 2.70135C5.63902 2.25502 6.67804 2.07418 7.70862 2.17789C8.73919 2.2816 9.72315 2.66602 10.5567 3.29062C11.3904 3.91522 12.0427 4.75686 12.4451 5.72681C12.8474 6.69676 12.9849 7.75909 12.8429 8.8018C12.7009 9.8445 12.2848 10.829 11.6384 11.6514C10.992 12.4738 10.1393 13.1037 9.1701 13.4747C8.20094 13.8457 7.15125 13.9441 6.1317 13.7594L5.1827 13.632V15.8261L5.93275 15.907C7.00383 16.0745 8.0974 16.0153 9.14495 15.7332C10.1925 15.4512 11.1714 14.9523 12.0205 14.2677C12.8695 13.5832 13.5703 12.7279 14.079 11.7553C14.5877 10.7827 14.8933 9.71376 14.9767 8.61553C15.06 7.51729 14.9194 6.41338 14.5635 5.37296C14.2077 4.33254 13.6443 3.37803 12.9086 2.56922C12.173 1.76041 11.2809 1.11474 10.2883 0.672647C9.29576 0.230555 8.22407 0.00157071 7.14039 4.02014e-05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.9923L5 22V8L3.01885 9.59047L3 21.9923Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22L0 21.9943L0.0188667 11.3638L2 10V22Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParIcon);
export default __webpack_public_path__ + "static/media/par-icon.0e9a0b6adfe5b6720a0780f3bf799234.svg";
export { ForwardRef as ReactComponent };